import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConsumiFeModalComponent } from './consumi-fe-modal';

export const ConsumiFeModalModule: string = ng
    .module('archiSmall.components.consumiFeModalModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('consumiFeModalComponent', ConsumiFeModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/consumi-fe-modal/consumi-fe-modal.module.ts